import styled from 'styled-components';

export const DataTableMuiContainer = styled.div`
    margin-top: 32px;
`

export const SectionContainer = styled.div`
    display: flex;
    flex-direction: row;

    @media (max-width: 960px) {
        flex-direction: column;
        align-items: end;
    }
`;
export const FirstColumn = styled.div`
    margin: 0 24px 0 0;
    width: 100%;

    @media (max-width: 960px) {
        margin: 0;
    } 
`;
export const Row = styled.div`
    display: flex;
    gap: 24px;

    @media (max-width: 960px) {
        flex-direction: column;
        gap: 0;
        width: 100%;
    }
`;
export const SecondColumn = styled.div`
    display:flex;
    align-items:flex-end;
    margin: 0 0 24px 0;

    @media (max-width: 960px) {
        width: 100%;
        
        & button {
            width: 100%;
        }
    }
`;
 